import firebase from 'firebase/app';
import 'firebase/auth';
import { environment } from './environment';

export default !firebase.apps.length ? firebase.initializeApp(environment.firebaseConfig) : firebase.app()